// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__22UId","selects":"Documents_selects__6r1L1"};